import { createApi } from '@reduxjs/toolkit/query/react';

import { TagTypesEnum } from '@enum/tag-types.enum';
import {
  ConnectionInputInterface,
  ConnectionInterface,
  ConnectionMetaInputInterface,
} from '@interface/connection/connection.interface';
import { ConnectorInterface } from '@interface/connector/connector.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { apiQueryAuth } from '@util/api/api-query-auth';

export const connectionApi = createApi({
  reducerPath: 'connection-api',
  tagTypes: [TagTypesEnum.Connection, TagTypesEnum.Integration],
  baseQuery: apiQueryAuth('/connections'),
  endpoints: (build) => ({
    loadConnections: build.query<ResponseDataInterface<ConnectionInterface[]>, undefined>({
      query: () => '/',
      providesTags: [TagTypesEnum.Connection],
    }),
    loadApplicationConnections: build.query<ResponseDataInterface<ConnectionInterface[]>, undefined>({
      query: () => '/',
      providesTags: [TagTypesEnum.Connection],
    }),
    getConnection: build.query<ResponseDataInterface<ConnectionInterface>, ConnectorInterface>({
      query: (connector: ConnectorInterface) => `/${connector.unifiedApi}/${connector.serviceId}`,
    }),
    saveConnection: build.mutation<ResponseDataInterface<ConnectionInterface>, ConnectionInputInterface>({
      query: (credentials: ConnectionInputInterface) => ({
        url: `/${credentials.unifiedApi}/${credentials.serviceId}`,
        method: 'PATCH',
        body: credentials,
      }),
      invalidatesTags: [TagTypesEnum.Connection, TagTypesEnum.Integration],
    }),
    saveConnectionMeta: build.mutation<ResponseDataInterface<ConnectionInterface>, ConnectionMetaInputInterface>({
      query: (credentials: ConnectionMetaInputInterface) => {
        const formData = new FormData();
        formData.append('settings[idpMetadata]', credentials.file);

        return {
          url: `/${credentials.unifiedApi}/${credentials.serviceId}`,
          method: 'PATCH',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: [TagTypesEnum.Connection, TagTypesEnum.Integration],
    }),
    deleteConnection: build.mutation<
      ResponseDataInterface<any>,
      Pick<ConnectionInputInterface, 'serviceId' | 'unifiedApi'>
    >({
      query: (credentials: Pick<ConnectionInputInterface, 'serviceId' | 'unifiedApi'>) => ({
        url: `/${credentials.unifiedApi}/${credentials.serviceId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TagTypesEnum.Connection, TagTypesEnum.Integration],
    }),
  }),
});
